window.dataLayer = window.dataLayer || [];
hookCalendlyDataLayer();

const newsBanner = document.querySelector('.news-banner');
const menuToggle = document.getElementById('menu-toggle');
const menu = document.getElementById('menu');
const openMenu = document.getElementById('openMenu');
const closeMenu = document.getElementById('closeMenu');
const navbar = document.getElementById('navbar');
const subscribeBtn = document.getElementById('subscribeBtn');
const chatToggle = document.getElementById('chat-contact-toggle');
const dropdowns = document.querySelectorAll('.nav-dropdown');
const dropdownsToggles = document.querySelectorAll('.toggleDropdown');
const dropdownList = document.querySelectorAll('.nav-dropdown-list');

const dayInMilliseconds = 24 * 60 * 60 * 1000;
const EXPIRING_TIME = 7 * dayInMilliseconds;
const CALENDLY_STORAGE_KEY = 'calendly_scheduled_v1';

export function isCalendlyScheduledActive() {
	const raw = localStorage.getItem(CALENDLY_STORAGE_KEY);
	if (!raw) {
		return false;
	}

	try {
		const data = JSON.parse(raw);
		return typeof data.expiresAt === 'number' && data.expiresAt > Date.now();
	} catch {
		return false;
	}
}

function markCalendlyScheduled() {
	const now = Date.now();
	localStorage.setItem(
		CALENDLY_STORAGE_KEY,
		JSON.stringify({ scheduledAt: now, expiresAt: now + EXPIRING_TIME }),
	);
}

function hookCalendlyDataLayer() {
	if (!Array.isArray(window.dataLayer)) {
		return;
	}

	window.dataLayer.forEach((it) => {
		if (it?.event === 'calendly' && it?.calendly_event === 'event_scheduled') {
			markCalendlyScheduled();
		}
	});

	const originalPush = window.dataLayer.push;
	window.dataLayer.push = function (...args) {
		args.forEach((it) => {
			if (
				it?.event === 'calendly' &&
				it?.calendly_event === 'event_scheduled'
			) {
				markCalendlyScheduled();
			}
		});
		return originalPush.apply(this, args);
	};
}

function attachCalendlyCloseButtonToPopupDesktop() {
	const desktopMinWidth = 1024;

	const moveCloseButtonIntoPopup = () => {
		if (window.innerWidth < desktopMinWidth) {
			return;
		}

		const overlay = document.querySelector('.calendly-overlay');
		if (!overlay) {
			return;
		}

		const popup = overlay.querySelector('.calendly-popup');
		const closeButton = overlay.querySelector('.calendly-popup-close');
		if (!popup || !closeButton) {
			return;
		}

		if (closeButton.parentElement !== popup) {
			popup.appendChild(closeButton);
		}
	};

	const initObserver = () => {
		moveCloseButtonIntoPopup();

		const observer = new MutationObserver(() => {
			moveCloseButtonIntoPopup();
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true,
		});
	};

	if (document.body) {
		initObserver();
		return;
	}

	document.addEventListener('DOMContentLoaded', initObserver, { once: true });
}

attachCalendlyCloseButtonToPopupDesktop();

let prevScrollpos = window.scrollY;

window.addEventListener('scroll', function (_) {
	if (newsBanner) {
		let currentScrollPos = window.scrollY;
		if (currentScrollPos > prevScrollpos && currentScrollPos > 180) {
			newsBanner.style.maxHeight = 0;
			newsBanner.style.minHeight = 0;

			newsBanner.style.padding = 0;
		} else {
			if (window.scrollY === 0) {
				newsBanner.style.maxHeight = '';
				newsBanner.style.minHeight = '40px';
				newsBanner.style.padding = '12px';
			}
		}
		prevScrollpos = currentScrollPos;
	}
});

subscribeBtn?.addEventListener('click', () => {
	menu.classList.toggle('block');
});

const toggleChanger = () => {
	menu.classList.toggle('hidden');
	if (!menu.classList.contains('hidden')) {
		chatToggle.classList.add('hidden');
		navbar.classList.add('-translate-y-full');
	} else {
		navbar.classList.remove('-translate-y-full');
		chatToggle.classList.remove('hidden');
	}
};

menuToggle?.addEventListener('change', toggleChanger);

dropdownList?.forEach((el) => {
	el.addEventListener('mouseleave', () => {
		el.classList.remove('active');
		const parentElement = el.parentElement;
		parentElement.classList.remove('active');
	});
});

function toggleDropdowns(el) {
	return () => {
		// Close all dropdown submenus and remove border color
		dropdowns.forEach((dropdownParent) => {
			if (dropdownParent !== el) {
				dropdownParent.classList.remove('active');
			}
		});
		dropdownList.forEach((dropdown) => {
			if (dropdown !== el.querySelector('.nav-dropdown-list')) {
				dropdown.classList.remove('active');
			}
		});

		// toggle active class on the clicked dropdown
		el.querySelector('.nav-dropdown-list')?.classList.toggle('active');
		el.classList.toggle('active');
	};
}

dropdowns?.forEach((el) => {
	el.addEventListener('click', toggleDropdowns(el));
});

dropdownsToggles.forEach((it) => {
	it.addEventListener('keydown', (e) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			toggleDropdowns(it.closest('.nav-dropdown'))();
		}
	});
});

if (openMenu) {
	openMenu.addEventListener('keydown', (e) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			toggleChanger();
		}
	});
}

if (closeMenu) {
	closeMenu.addEventListener('keydown', (e) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			toggleChanger();
		}
	});
}

export default menuToggle;
